export interface RoutePlanGate {
  module?: string
  feature?: string
}

const ROUTE_PLAN_GATES: Record<string, RoutePlanGate> = {
  crm: { module: 'crm_core' },
  opportune: { module: 'crm_core' },
  oportunidades: { module: 'crm_core' },
  'crm-history': { module: 'crm_core' },
  'lead-list': { module: 'crm_core' },
  painel: { module: 'crm_core' },
  e_template: { module: 'crm_core' },
  temp_list: { module: 'crm_core' },
  temp_create: { module: 'crm_core' },
  temp_edit: { module: 'crm_core' },

  e_bot: { module: 'atendimento' },

  agenda: { module: 'agenda_tasks' },
  tarefas: { module: 'agenda_tasks' },

  veiculo: { module: 'veiculo' },
  v_list: { module: 'veiculo' },
  v_sold: { module: 'veiculo' },
  v_create: { module: 'veiculo' },
  v_edit: { module: 'veiculo' },
  v_doc: { module: 'veiculo' },
  v_pho: { module: 'veiculo' },

  negociacao: { module: 'negociacao' },
  'propostas-list': { module: 'negociacao' },
  'proposta-create': { module: 'negociacao' },
  'proposta-detail': { module: 'negociacao' },
  'proposta-edit': { module: 'negociacao' },
  'proposta-itens': { module: 'negociacao' },
  'propostas-kanban': { module: 'negociacao' },
  'propostas-dashboard': { module: 'negociacao' },

  contato: { module: 'contato' },
  cont_list: { module: 'contato' },
  cont_create: { module: 'contato' },
  cont_edit: { module: 'contato' },
  'tags-list': { module: 'contato' },
  'tags-create': { module: 'contato' },
  'tags-edit': { module: 'contato' },

  cliente: { module: 'cliente' },
  c_list: { module: 'cliente' },
  c_create: { module: 'cliente' },
  c_edit: { module: 'cliente' },
  c_doc: { module: 'cliente' },

  venda: { module: 'venda' },
  ve_list: { module: 'venda' },
  ve_create: { module: 'venda' },
  ve_edit: { module: 'venda' },
}

export function getRoutePlanGate(routeName: unknown): RoutePlanGate | null {
  if (!routeName) return null
  return ROUTE_PLAN_GATES[String(routeName)] || null
}
